<template>
  <div class="bankBalance">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :setting="false"
        :paging="true"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          type="index"
          :title="$t('currenciesAndCalendar.queryCurrencies.index')"
          width="60"
        >
        </vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.prop"
          :title="item.label"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.prop] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.prop] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.optionList">
              {{ getSelectLabel(scope.row[item.prop], item.optionList) }}
              <!-- {{ getSelectLabel(scope.row.foreignCurrencyType, currencyList, "currencyCode", "currencyName") }} -->
            </span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import SiruiTable from '@/components/SiruiTable';
  import SiruiSearch from '@/components/SiruiSearch';
  import { mapState } from 'vuex';
  import BASEAPI from '@/api/dataBase.js';
  import API from '@/api/capitalPlane/foundFrecast';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'bankBalance',
    components: {
      SiruiTable,
      SiruiSearch,
    },
    props: {
      currentType: {
        type: String,
        default: 'CNY',
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            //公司
            prop: 'forecastCompanyCode',
            name: this.$t('fundFrecast.column.company'),
            type: 'select',
            options: this.companyList,
            span: 6,
          },
          {
            //开始日期
            prop: 'startForecastDate',
            name: this.$t('fundFrecast.column.startForecastDate'),
            type: 'date',
            span: 6,
          },
          {
            //结束日期
            prop: 'endForecastDate',
            name: this.$t('fundFrecast.column.endForecastDate'),
            type: 'date',
            span: 6,
          },
          /* {
          //计划周期
          prop: "planCycle",
          name: this.$t("fundFrecast.column.planCycle"),
          type: "dict",
          dictType:"capitalPlan_plan_week",
          span: 8
        }, */
          {
            //币别
            prop: 'currencyType',
            name: this.$t('fundFrecast.column.currencyType'),
            type: 'select',
            options: this.currencyList,
            span: 6,
          },
        ];
      },
      //表格显示字段
      columnList() {
        return [
          { prop: 'forecastDate', label: this.$t('fundFrecast.column.forecastDate') },
          { prop: 'balanceAmount', label: this.$t('fundFrecast.column.bankRestAmount') },
          //{ prop: "planCycle", label: this.$t("fundFrecast.column.planCycle"),dictType: "capitalPlan_plan_week" },
          {
            prop: 'currencyType',
            label: this.$t('fundFrecast.column.currencyType'),
            optionList: this.currencyList,
          },
        ];
      },
    },
    data() {
      return {
        load: false,
        dialogTableVisible: false,
        menuButtonList: [], //按钮
        companyList: [], //公司
        currencyList: [], //币别
        planWeekList: [], //计划周期
        departmentList: [], //部门

        query: {
          // 搜索条件
          forecastCompanyCode: null, //公司
          startForecastDate: null, //日期
          endForecastDate: null, //日期
          //planCycle:'MP',
          currencyType: this.currentType,
        },

        tableData: [],
      };
    },
    mounted() {
      this.getButtonList();
      this.getCompany();
      this.getCurrencyList();
      //this.getPlanWeekList();
    },
    methods: {
      getData() {
        if (this.query.forecastCompanyCode == '') {
          this.$message.warning(this.$t('fundFrecast.placeholder.company'));
          return;
        }
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = JSON.parse(JSON.stringify(this.query));
        params = Object.assign(params, { pageNum, pageSize });
        this.$axios.post(API.QUERY_FUND_PLAN_BALANCE_RECORDS, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //编辑表格回显方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //获取计划周期
      async getPlanWeekList() {
        let params = {
          dictType: 'capitalPlan_plan_week',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.planWeekList = selectStatus.data.data;
        }
      },
      //获取币别
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          selectStatus.data.data.map((item) => {
            let obj = {
              value: item.currencyCode,
              label: item.currencyName,
            };
            this.currencyList.push(obj);
          });
        }
      },
      //公司代码
      async getCompany() {
        let res = await this.$baseRequest.getCompanyList();
        if (res) {
          this.companyList = res;
          this.query.forecastCompanyCode = this.userInfo.companyCode || this.companyList[0].value;
        }
        this.getData();
      },
      //表格日期组件回调
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      //获取按钮
      getButtonList() {
        this.menuButtonList = [];
      },

      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'export') {
          //导出
          this.handleExport();
        } else if (type == 'total') {
          //合计
          this.showTotal();
        } else if (type == 'maintainBankBalance') {
          //维护银行余额
          this.dialogTableVisible = true;
        }
      },
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      //搜索
      searchBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getCompany();
      },

      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      // 导出
      handleExport() {
        if (this.tableData.length == 1 && this.tableData[0].totalFlag) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        let params = { ...this.query };
        params = this.$baseRequest.assignObj(params);
        params = XEUtils.serialize(params);
        window.location.href = `${baseUrl}${API.FORECAST_EXPORT_EXCEL}?${params}&access_token=${this.userInfo.access_token}`;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .bankBalance .el-dialog__footer {
    padding: 12px 18px;
    border-top: 1px solid #e8eaec;
    text-align: center !important;
  }
  .bankBalance .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }
</style>
